export default __webpack_public_path__ + "static/media/snowshoes_dark.6ac1a52b.png";